import { useContext } from 'react'
import { BillingContext } from '../context/BillingContext'

const useBillingContext = () => useContext(BillingContext)

export default useBillingContext